// components/CustomButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import '../css/GlobalReport.css';

const CustomButton = ({
  onClick,
  label,
  variant = '',
  type = 'button',
  className = '',
  children,
  isLoading = false,
  disabled = false,
  ...rest
}) => {
  const baseClass = 'sob-report-btn';
  const variantClass = variant ? `sob-${variant}-btn` : '';
  const fullClassName = `${baseClass} ${variantClass} ${className}`.trim();

  return (
    <button
      onClick={onClick}
      className={fullClassName}
      type={type}
      disabled={isLoading || disabled}
      aria-busy={isLoading}
      {...rest}
    >
      {/* Left icon */}
      {children && <span className="sob-btn-icon">{children}</span>}

      {/* Label or Loading */}
      <span className="sob-btn-label">
        {isLoading ? 'Loading...' : label}
      </span>
    </button>
  );
};

CustomButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  variant: PropTypes.oneOf([
    // core system buttons
    'print', 'export', 'go', 'save', 'update', 'cancel',
    'edit', 'delete', 'add', 'history', 'download',
    'submit', 'return',

    // new attractive designs
    'primary-grad',
    'ghost',
    'neu',
    'glass',
    'pill-icon',
     'green',
    'login',
    
  ]),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default CustomButton;
